import React from "react";
import { Button, Input, Dropdown, Grid } from "semantic-ui-react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import cx from "classnames";

const JobsFilter = observer(
  ({ query, status, statusOptions, onQueryChange, onStatusChange, onSearchClick, onCreatePhotoEditingJobClick }) => (
    <Grid columns={4}>
      <Grid.Row className="no-overflow">
        <Grid.Column>
          <Input
            fluid
            name="query"
            id="query"
            placeholder="Job ID or label"
            value={query}
            onChange={e => onQueryChange(e.target.value)}
            onKeyDown={e => e.key === "Enter" && onSearchClick()}
          />
        </Grid.Column>
        <Grid.Column>
          <Dropdown
            fluid
            selection
            placeholder="Any Status"
            options={statusOptions}
            value={status}
            onChange={(_e, selection) => onStatusChange(selection.value)}
            onKeyDown={e => e.key === "Enter" && onSearchClick()}
          />
        </Grid.Column>
        <Grid.Column textAlign="center">
          <Button fluid type="button" secondary onClick={onSearchClick}>
            Search
          </Button>
          <a
            className={cx({ "clear-search": true, unclickable: query === "" && status === "" })}
            href="#"
            onClick={e => {
              e.preventDefault();

              // do not allow clicking if the form is already cleared.
              if (query === "" && status === "") {
                return;
              }

              onQueryChange("");
              onStatusChange("");
              onSearchClick();
            }}
          >
            clear search
          </a>
        </Grid.Column>
        <Grid.Column>
          {onCreatePhotoEditingJobClick ? (
            <Button fluid primary onClick={onCreatePhotoEditingJobClick}>
              Create
            </Button>
          ) : null}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  ),
);

JobsFilter.propTypes = {
  query: PropTypes.string,
  status: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  statusOptions: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      text: PropTypes.string.isRequired,
    }),
  ),
  onQueryChange: PropTypes.func.isRequired,
  onStatusChange: PropTypes.func.isRequired,
  onSearchClick: PropTypes.func.isRequired,
  // optional. Only used when outside react-router context like in tour edit page's HDR tab.
  onCreatePhotoEditingJobClick: PropTypes.func,
};

export default JobsFilter;
